/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState, useMemo } from "react";
import {
  IconDownload,
  IconAdjustmentsHorizontal,
  IconRefresh,
  IconX,
  IconPackage,
  IconRotateClockwise,
  IconInfoCircle,
  IconSearch,
} from "@tabler/icons-react";
import { useIntegrationChannelsAll } from "../../../apis/integrationApis";
import NormalSearch from "../../../components/common/NormalSearch";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import FilterSidebar from "./FilterSidebar";
import AddOrdersModals from "./AddOrdersModals";
import ReverseOrderModal from "./ReverseOrderModal";
import {
  useOrderForwardBulkMutation,
  useOrderReverseMutation,
  useOrderStatusRevertMutation,
  useOrderStatusRevertStatusMutation,
  useOrderStatusUpdateStatusMutation,
  useOrderSyncMutation,
} from "../../../apis/orderApis";
import {
  useFetchOrderOperations,
  useCreateOrderMutation,
} from "../../../apis/operationApis";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import useDebounce from "../../../utilities/useDebounce";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import Pagination from "../../../components/common/Pagination";
import MessageModal from "../../../components/MessageModal";
import { use3PLListData } from "../../../apis/3plApis";
import AllOrderTable from "./AllOrderTable";
import RoleToggle from "../../../components/RoleToggle";
import NoDataFound from "../../../components/common/NoDataFound";
import { useSelector } from "react-redux";
import { usePermission } from "../../../hooks/usePermissionTabs";
import OrderBulkUploadModals from "./OrderBulkUploadModals";
import EntriesSelector from "../../../components/common/EntriesSelector";
import * as XLSX from "xlsx";
import BulkStatusRevertModal from "./BulkStatusRevertModal";
import NewCommonModalCenter from "../../../components/common/NewCommonModalCenter";
import BulkForwardModal from "./BulkForwardModal";
import NewSelectInput from "../../../components/NewSelectInput";
import NewinputField from "../../../components/NewInput";
import { useLanguage } from "../../../context/LanguageContext";
import { useWarehouseListData } from "../../../apis/warehouseApi";
import BulkPdfModal from "./LablePrintBulkpdf";
import { useMerchantAllListData } from "../../../apis/merchantApis";
import BulkStatusUpdateModal from "../../CreatedOrders/_components/BulkStatusUpdateModal";
import {
  usePickupLocationClientAddressData,
  usePickRequestMutation,
} from "../../../apis/pickupApis";
import {
  useBulkReverseNaqelShipmentMutation,
  useNaqelBulkForwardMutation,
  useReverseNaqelShipmentMutation,
} from "../../../apis/naqelApis";
import {
  useAramexBulkForwardMutation,
  useAramexBulkReverseMutation,
  useAramexReverseShipmentMutation,
} from "../../../apis/aramexApis";

type Props = {
  pending?: boolean;
  filters?: Array<Record<string, string>>;
  setFilters?: (filters: Array<Record<string, string>>) => void;
  onPackOrder?: (awb: string) => void;
  setHeaderActions?: (node: React.ReactNode) => void;
  setHeaderButtons?: (node: React.ReactNode) => void;
};

const ActionTypeData = [
  { id: 1, value: "forward", text: "3PL Forward" },
  { id: 2, value: "labelPrint", text: "3PL Label Print" },
  { id: 3, value: "forwardReverse", text: "Forward Reverse" },
  { id: 4, value: "statusRevert", text: "Status Revert" },
  { id: 5, value: "reverseOrder", text: "Reverse Order" },
  { id: 6, value: "generatePickup", text: "Generate Pickup" },
  { id: 7, value: "orderbulkpdf", text: "PDF Generate" },
  { id: 8, value: "returnTo3PL", text: "3PL Return" },
  { id: 11, value: "statusUpdate", text: "Status Update" },
];

const ORDER_STATUS_OPTIONS = [
  { id: "NEW_ORDER", value: "NEW_ORDER", text: "New Order" },
  {
    id: "PICKUP_GENERATED",
    value: "PICKUP_GENERATED",
    text: "Pickup Generated",
  },
  {
    id: "READY_FOR_PICKUP",
    value: "READY_FOR_PICKUP",
    text: "Ready For Pickup",
  },
  {
    id: "PICKUP_COLLECTED",
    value: "PICKUP_COLLECTED",
    text: "Pickup Collected",
  },
  {
    id: "RECEIVE_INBOUND",
    value: "RECEIVE_INBOUND",
    text: "Received In Warehouse",
  },
  { id: "SHELVE", value: "SHELVE", text: "Shelve" },
  { id: "FORWARD_TO_3PL", value: "FORWARD_TO_3PL", text: "Forward To 3PL" },
  {
    id: "OUT_FOR_DELIVERY",
    value: "OUT_FOR_DELIVERY",
    text: "Out For Delivery",
  },
  { id: "REVERSE_NEW", value: "REVERSE_NEW", text: "Reverse New" },
  { id: "IN_TRANSIT", value: "IN_TRANSIT", text: "In Transit" },
  { id: "DELIVERED", value: "DELIVERED", text: "Delivered" },
  { id: "NOT_DELIVERED", value: "NOT_DELIVERED", text: "Not Delivered" },
  { id: "RETURNED", value: "RETURNED", text: "Returned" },
  { id: "CANCELLED", value: "CANCELLED", text: "Cancelled" },
  { id: "DELETED", value: "DELETED", text: "Deleted" },
  { id: "PENDING", value: "PENDING", text: "Pending" },
  {
    id: "RETURN_TO_SHIPPER",
    value: "RETURN_TO_SHIPPER",
    text: "Return To Shipper",
  },
];

export default function AllOrders({
  pending,
  filters: parentFilters,
  setFilters: setParentFilters,
  onPackOrder,
  setHeaderActions,
  setHeaderButtons,
}: Props) {
  const { allowed: canUpdatePackaging } = usePermission("packaging", "update");
  const { allowed: canUpdateOrder } = usePermission("orders", "update");
  const { t } = useLanguage();
  const [showModal, setShowModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showReverseModal, setShowReverseModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openForword, setOpenForword] = useState(false);
  const [openActions, setOpenActions] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const toggleFilter = () => setShowFilter(!showFilter);
  const [selectedClientId, setSelectedClientId] = useState<string | null>(null);
  const [clientLocations, setClientLocations] = useState<any[]>([]);

  const [isReverseOrderWiseOpen, setIsReverseOrderWiseOpen] = useState(false);
  const [isRevertOrder, setIsRevertOrder] = useState(false);
  const [order, setOrder] = useState<any>();
  const [searchFor, setSearchFor] = useState<string>("");
  const [showSearch, setShowSearch] = useState(false);
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);

  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false); // Controls checkbox visibility
  const [selectedOrders, setSelectedOrders] = useState<any[]>([]); // Tracks selected orders

  const [orderItemId, setOrderItemId] = useState<any>(null);
  const [openResponse, SetOpenResponse] = useState<boolean | string>(false);
  const [orderBulkResponse, setOrderBulkResponse] = useState<any>(null);
  const { mutate: reverseOrderMutate, isPending: isReverseOrderPending } =
    useOrderReverseMutation();
  const { mutate: revertOrderMutate } = useOrderStatusRevertMutation(
    order?.id ?? "",
  );
  const [showBulkStatusModal, setShowBulkStatusModal] = useState(false);
  const { data: shippingPartners } = use3PLListData();

  const { mutate: orderStatusRevertMutate, isPending: isStatusRevertPending } =
    useOrderStatusRevertStatusMutation();
  const { mutate: orderForwardBulkMutate, isPending: isOrderForwardPending } =
    useOrderForwardBulkMutation();
  // BUlk Forward & Print for Naqel Express
  const {
    mutate: naqelBulkForwardMutate,
    // isPending: isNaqelBulkForwardPending,
  } = useNaqelBulkForwardMutation();

  // Bulk Forward & Print for Aramex
  const {
    mutate: aramexBulkForwardMutate,
    // isPending: isAramexBulkForwardPending,
  } = useAramexBulkForwardMutation();

  // Return & Reverse for Naqel Express
  const {
    mutate: reverseNaqelOrderMutate,
    isPending: isReverseNaqelOrderPending,
  } = useBulkReverseNaqelShipmentMutation();

  const {
    mutate: reverseAramexOrderMutate,
    isPending: isReverseAramexOrderPending,
  } = useAramexBulkReverseMutation();

  const { mutate: syncMutate } = useOrderSyncMutation();

  const [activeTab, setActiveTab] = useState("Pending");
  const getStatusFromTab = (tab: string) => {
    if (tab === "Pending") return "PICKED";
    return undefined;
  };
  const [filters, setFilters] = useState<Array<Record<string, string>>>(
    parentFilters || [],
  );
  const { data: warehouses } = useWarehouseListData();
  const { data: clients } = useMerchantAllListData();
  const { data: shippingPlatforms } = useIntegrationChannelsAll("shipping");

  const merchantOptions = useMemo(() => {
    return [
      ...(clients?.map((c: any) => ({
        id: c.id,
        value: c.name,
        text: c.name,
      })) || []),
    ];
  }, [clients]);

  const platformOptions = useMemo(() => {
    const set = new Set<string>();
    set.add("Salla");
    set.add("Zid");
    if (shippingPlatforms) {
      shippingPlatforms.forEach((sp: any) => {
        if (sp.companyName) set.add(sp.companyName);
      });
    }
    return Array.from(set).map((p) => ({ id: p, value: p, text: p }));
  }, [shippingPlatforms]);

  const selectedMerchant = filters.find((f) => f.hasOwnProperty("seller"))?.seller || "All";
  const selectedPlatform = filters.find((f) => f.hasOwnProperty("platform"))?.platform || "All";

  const handleMerchantChange = (merchant: string) => {
    setFilters((prev) => {
      const newFilters = prev.filter((f) => !f.hasOwnProperty("seller"));
      if (merchant && merchant !== "All") {
        newFilters.push({ seller: merchant });
      }
      return newFilters;
    });
  };

  const handlePlatformChange = (platform: string) => {
    setFilters((prev) => {
      const newFilters = prev.filter((f) => !f.hasOwnProperty("platform"));
      if (platform && platform !== "All") {
        newFilters.push({ platform: platform });
      }
      return newFilters;
    });
  };

  const handleReset = () => {
    setSearchFor("");
    setFilters([]);
    setPageNo(1);
    toast.success("Filters reset successfully");
  };

  const hasActiveFilters = searchFor !== "" || filters.length > 0;

  const { mutate: generatePickupMutate } = usePickRequestMutation();
  const { mutate: createOrderMutate, isPending: isCreateOrderPending } =
    useCreateOrderMutation();

  useEffect(() => {
    if (parentFilters) {
      setFilters(parentFilters);
    }
  }, [parentFilters]);

  const debouncedSearchFor = useDebounce(searchFor, 550);

  const {
    data: ordersData,
    isPending: listPending,
    refetch,
  } = useFetchOrderOperations(getStatusFromTab(activeTab), pageNo, limit, debouncedSearchFor, filters);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, activeTab, limit, filters, pending, refetch]);

  const {
    register: statusRevertRegister,
    setValue: setRevertStatusValue,
    clearErrors: revertStatusClearErrors,
    formState: { errors: revertStatusErrors },
    watch: revertStatusWatch,
    control: revertStatusControl,
    reset: statusRevertReset,
    handleSubmit: handleRevertStatusSubmit,
  } = useForm<any>();
  console.log(revertStatusControl);

  const orders = useSelector((state: any) => state.orders.list);

  const openReverseOrderWiseModal = () => setIsReverseOrderWiseOpen(true);
  const closeReverseOrderWiseModal = () => setIsReverseOrderWiseOpen(false);
  const closeRevertOrder = () => setIsRevertOrder(false);

  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const dropdownForwardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutsideForward = (event: MouseEvent) => {
      if (
        dropdownForwardRef.current &&
        !dropdownForwardRef.current.contains(event.target as Node)
      ) {
        setOpenForword(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideForward);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideForward);
    };
  }, []);

  // Label Print Modal State
  const [showBulkPdfModal, setShowBulkPdfModal] = useState(false);
  const [bulkPdfOrders, setBulkPdfOrders] = useState<any[]>([]);
  const [bulkPdfCompany, setBulkPdfCompany] = useState<string>("");

  const handleCreateOrder = () => {
    if (selectedOrders.length === 0) {
      toast.error("Please select at least one order to create an order");
      return;
    }

    // Prepare the payload with all selected order details
    const orderPayload = {
      orders: selectedOrders,
      totalOrders: selectedOrders.length,
    };

    createOrderMutate(orderPayload, {
      onSuccess: (response) => {
        toast.success(response?.message || "Order created successfully!");
        console.log("Order created:", response);
        // Clear selection after successful creation
        setSelectedOrders([]);
        setIsCheckboxEnabled(false);
        // Optionally refresh the orders list
        refetch();
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "Failed to create order";
        toast.error(errorMessage);
        console.error("Create order error:", error);
      },
    });
  };

  const handleSelect = (value: string) => {
    setSelectedOption(value);
    setOpen(false);

    if (value === "NewOrder") setShowModal(true);
    else if (value === "BulkOrder") setShowBulkModal(true);
    else if (value === "ReverseOrder") setShowReverseModal(true);
    else if (value === "orderbulkpdf") {
      setBulkPdfOrders(
        selectedOrders.length > 0 ? selectedOrders : orders?.orders || [],
      );
      setShowBulkPdfModal(true);
    }
  };

  const options = [
    { label: "New Order", value: "NewOrder" },
    { label: "Upload", value: "BulkOrder" },
    { label: "Reverse Order", value: "ReverseOrder" },
  ];

  const [columns, setColumns] = useState([
    { id: 1, text: "S/N", value: "sn", isShow: true },
    { id: 2, text: "TAG", value: "tag", isShow: true },
    { id: 3, text: "DATE", value: "createdDate", isShow: true },
    { id: 4, text: "PLATFORM", value: "platform", isShow: true },
    { id: 5, text: "AWB & REF", value: "awbRef", isShow: true },
    { id: 6, text: "WAREHOUSE", value: "warehouse", isShow: true },
    { id: 7, text: "ROUTE", value: "route", isShow: true },
    { id: 8, text: "3PL SHIPPING DETAILS", value: "shippingDetails", isShow: true },
    { id: 9, text: "ORIGIN", value: "origin", isShow: true },
    { id: 10, text: "DESTINATION", value: "destination", isShow: true },
    { id: 11, text: "RECEIVER", value: "receiverDetails", isShow: true },
    { id: 12, text: "PAYMENT", value: "paymentInfo", isShow: true },
    { id: 13, text: "MERCHANT", value: "merchant", isShow: true },
    { id: 14, text: "STATUS", value: "status", isShow: true },
    { id: 15, text: "ACTIONS", value: "actions", isShow: true },
  ]);

  const showRightPanel = showBulkStatusModal;

  // Track initial/default columns to restore them when sidebar is closed
  const [defaultVisibleColumns, setDefaultVisibleColumns] = useState<string[]>([]);
  useEffect(() => {
    if (columns.length > 0 && defaultVisibleColumns.length === 0) {
      const visible = columns.filter((col) => col.isShow).map((col) => col.value);
      setDefaultVisibleColumns(visible);
    }
  }, [columns]);

  // Handle auto-shrinking table columns when right sidebar is open
  useEffect(() => {
    if (showRightPanel) {
      const essentialColumns = ["tag", "awbRef", "route", "platform", "merchant", "status", "actions"];
      setColumns((prev) =>
        prev.map((col) => ({
          ...col,
          isShow: essentialColumns.includes(col.value),
        }))
      );
    } else if (defaultVisibleColumns.length > 0) {
      setColumns((prev) =>
        prev.map((col) => ({
          ...col,
          isShow: defaultVisibleColumns.includes(col.value),
        }))
      );
    }
  }, [showRightPanel, defaultVisibleColumns]);

  const syncOrder = () => {
    syncMutate(undefined, {
      onSuccess: (data) => {
        refetch();
        toast.success("Order synchronized successfully");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error || error.message || "Failed to delete order");
      },
    });
  };

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const handleReverseOrder = () => {
    reverseOrderMutate(
      { orderId: [orderItemId] },
      {
        onSuccess: (data) => {
          console.log(data, "data");
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      },
    );
    setIsReverseOrderWiseOpen(false);
  };
  const handleRevertOrder = () => {
    revertOrderMutate(undefined, {
      onSuccess: (data) => {
        refetch();
        setIsRevertOrder(false);
      },
      onError: (error) => {
        console.log(error, "error");
        toast.error(`${error}`);
      },
    });
  };

  const handleSetHeadings = (value: string | undefined, checked: boolean) => {
    setColumns((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };

  const handleSelectOrder = (order: any) => {
    setSelectedOrders((prev) => {
      if (prev.some((o) => o.id === order.id)) {
        return prev.filter((o) => o.id !== order.id); // Deselect
      }
      return [...prev, order]; // Select
    });
  };

  const handleDownloadXLSX = () => {
    if (!orders || !orders.orders || orders.orders.length === 0) {
      toast.error("No data available to download");
      return;
    }

    // Use selected orders if any, otherwise use all orders
    const dataToExport =
      selectedOrders.length > 0 ? selectedOrders : orders.orders;

    // If checkboxes are enabled but no items selected, show message
    if (selectedOrders.length === 0 && isCheckboxEnabled) {
      toast.error(
        "Please select at least one order to download, or disable selection to download all orders",
      );
      return;
    }

    // If no checkboxes enabled, enable them for future selective downloads
    if (!isCheckboxEnabled) {
      setIsCheckboxEnabled(true);
      setColumns((prev) =>
        prev.map((col) =>
          col.value === "checkbox" ? { ...col, isShow: true } : col,
        ),
      );
      toast.success(
        "Selection enabled! Downloading all orders. Select specific items next time for selective download.",
      );
    }

    // const visibleColumns = columns.filter((col) => col.isShow);

    const data = dataToExport.map((order: any, index: number) => {
      const row: any = {};
      columns.forEach((col) => {
        if (col.value === "sn") {
          row[col.text] =
            selectedOrders.length > 0
              ? index + 1
              : (pageNo - 1) * limit + (index + 1);
        } else if (col.value === "tag") {
          row[col.text] =
            order.orderType === "LM" ? `${order.orderType}-B2C` : "LM";
        } else if (col.value === "createdDate") {
          row[col.text] = order.createdAt
            ? new Date(order.createdAt).toLocaleDateString()
            : "";
        } else if (col.value === "platform") {
          row[col.text] = order.platform || "";
        } else if (col.value === "awbRef") {
          row["AWB Number"] = order.awbNumber || "";
          row["Reference"] = order.referenceNumber || "";
        } else if (col.value === "warehouse") {
          row[col.text] = order.warehouseName || "";
        } else if (col.value === "route") {
          row[col.text] = order.routeCode || "";
        } else if (col.value === "shippingDetails") {
          row["Shipping Company"] = order.shippingCompany || "";
          row["Shipping AWB"] = order.shippingAwbNumber || "";
        } else if (col.value === "origin") {
          row[col.text] = order.senderCityName || order.senderCityData || "";
        } else if (col.value === "destination") {
          row["Destination Country"] =
            order.receiverCountryName || order.receiverCountryData || "";
          row["Destination City"] =
            order.receiverCityName || order.receiverCityData || "";
          row["Destination District"] =
            order.receiverDistrictName || order.receiverDistrictData || "";
          row["Destination Street"] = order.receiverStreet || "";
        } else if (col.value === "receiverDetails") {
          row["Receiver Name"] = order.receiverName || "";
          row["Receiver Mobile"] = order.receiverMobile || "";
          row["Receiver Address"] =
            order.receiverAddress?.replace(/<[^>]*>/g, "") || "";
        } else if (col.value === "paymentInfo") {
          row["Payment Mode"] = order.paymentType || "";
          row["Payment Amount"] = order.codAmount || 0;
        } else if (col.value === "merchant") {
          row[col.text] = order.clientName || "";
        } else if (col.value === "status") {
          row[col.text] = order.status
            ? `${order?.subStatus
              ? `${order?.subStatus?.map(
                (word: string) =>
                  word.charAt(0).toUpperCase() + word.slice(1),
              )}/`
              : ""
            }${order.status
              .toLowerCase()
              .split("_")
              .map(
                (word: string) =>
                  word.charAt(0).toUpperCase() + word.slice(1),
              )
              .join(" ")}`
            : "";
        }
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");
    XLSX.writeFile(wb, "orders.xlsx");
    // Reset selections and checkboxes after download
    setSelectedOrders([]);
    setIsCheckboxEnabled(false);
    setColumns((prev) =>
      prev.map((col) =>
        col.value === "checkbox" ? { ...col, isShow: false } : col,
      ),
    );
  };
  const [actionValue, setActionValue] = useState("");

  const [openBsrModal, setOpenBsrModal] = useState<boolean>(false);
  const openBsrModalToggle = () => {
    setOpenBsrModal(!openBsrModal);
  };
  const [openForwardModal, setOpenForwardModal] = useState<boolean>(false);
  const openForwardModalToggle = () => {
    setOpenForwardModal(!openForwardModal);
  };
  const profile = useSelector((state: any) => state.auth.profile);

  // Geneate pickup
  useEffect(() => {
    if (actionValue !== "generatePickup") return;
    if (!selectedOrders.length || !clients?.length) return;

    const clientNames = selectedOrders.map((o) => o.clientName).filter(Boolean);
    const uniqueNames = clientNames.filter(
      (value, index, self) => self.indexOf(value) === index,
    );

    if (uniqueNames.length !== 1) return;

    const matchedClient = clients.find((c: any) => c.name === uniqueNames[0]);
    if (!matchedClient?.id) return;

    setRevertStatusValue("clientId", matchedClient.id);
    setRevertStatusValue("pickupType", "Shipment");
  }, [actionValue, selectedOrders, clients, setRevertStatusValue]);



  useEffect(() => {
    if (!selectedOrders.length || !ordersData?.data?.length) {
      setSelectedClientId(null);
      setClientLocations([]);
      return;
    }

    const fullOrders =
      ordersData?.data?.filter((o: any) =>
        selectedOrders.some((s: any) => s.id === o.id),
      ) || [];

    const clientIds = fullOrders
      .map((o: any) => o.clientId)
      .filter((v: any, i: any, self: any) => self.indexOf(v) === i);

    setSelectedClientId(clientIds[0]);
  }, [selectedOrders, orders, ordersData?.data]);

  const totalOrders = ordersData?.pagination?.total || ordersData?.data?.length || 0;

  useEffect(() => {
    if (setHeaderActions) setHeaderActions(null);
  }, [setHeaderActions]);

  useEffect(() => {
    if (!setHeaderButtons) return;

    setHeaderButtons(
      <div className="flex items-center gap-2 bg-white/70 backdrop-blur-sm px-4 py-1.5 rounded-xl border border-slate-200 shadow-sm text-[11px] select-none font-bold min-h-8">
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500">{t("Selected")}:</span>
          <span className="text-blue-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded">{selectedOrders.length}</span>
        </div>
        <span className="h-3 w-px bg-slate-300" />
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500">{t("Total")}:</span>
          <span className="text-slate-700 bg-slate-50 border border-slate-200 px-1.5 py-0.5 rounded">{totalOrders}</span>
        </div>
      </div>
    );

    return () => setHeaderButtons(null);
  }, [setHeaderButtons, selectedOrders.length, totalOrders]);

  return (
    <>
      <div className="grid grid-cols-12 gap-6 bg-[#F7F6F2] p-3 rounded-xl w-full items-start">
        {/* Left Side: Table & Filters */}
          <div className={showRightPanel ? "col-span-12 lg:col-span-7 xl:col-span-8 space-y-6" : "col-span-12 space-y-6"}>
            {/* ── Main Card (Header + Table Joined) ─────────────────────── */}
            <div
              className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-visible mb-6"
              style={{ minHeight: "150px" }}
            >

          {/* ── Header Row (Filters + Actions Unified) ──────────────── */}
          <div className="px-6 py-3.5">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">

              {/* Left side: Brand badge + Merchants filter + Platforms filter + Reset + Filters toggle */}
              <div className="flex flex-wrap items-center gap-3">
                <div className="bg-[#FBD037] text-[#131327] font-black text-sm px-3.5 py-1.5 rounded-xl tracking-wider shadow-sm select-none">
                  {t("Pending")}
                </div>

                {/* Merchant filter */}
                <NewSelectInput
                  name="merchant-filter"
                  placeholder={t("Merchants")}
                  value={selectedMerchant === "All" ? "" : selectedMerchant}
                  setValue={handleMerchantChange}
                  selectOptions={merchantOptions}
                  className="w-24 lg:w-28 font-semibold"
                  removeDiv
                  compact
                />

                {/* Platform filter */}
                <NewSelectInput
                  name="platform-filter"
                  placeholder={t("Platforms")}
                  value={selectedPlatform === "All" ? "" : selectedPlatform}
                  setValue={handlePlatformChange}
                  selectOptions={platformOptions}
                  className="w-24 lg:w-28 font-semibold"
                  removeDiv
                  compact
                />

                {/* Reset Button — only shown when a filter is active */}
                {hasActiveFilters && (
                  <button
                    onClick={handleReset}
                    className="flex items-center gap-1.5 px-2.5 py-1.5 bg-rose-50 hover:bg-rose-100 border border-rose-200 hover:border-rose-300 text-rose-600 rounded-md transition shadow-sm active:scale-95 duration-150 h-8 text-[11px] font-bold"
                    title={t("Reset Filters")}
                  >
                    <IconRotateClockwise size={14} stroke={2.5} />
                    {t("Reset")}
                  </button>
                )}


              </div>

              {/* Right side: Search + Sync + Export + Bulk Package Status + Limit + Columns + Count Badge */}
              <div className="flex items-center flex-wrap gap-2.5">
                {/* Sliding Search */}
                <div className="relative flex items-center group">
                  <div
                    onClick={() => {
                      if (!showSearch) {
                        setShowSearch(true);
                      }
                    }}
                    className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-lg bg-white shadow-sm h-8 ${
                      showSearch
                        ? "w-64 px-2 cursor-default"
                        : "w-8 justify-center cursor-pointer hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95"
                    }`}
                  >
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSearch(!showSearch);
                      }}
                      className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
                    >
                      <IconSearch size={17} stroke={2.5} />
                    </button>
                    {showSearch && (
                      <>
                        <input
                          type="text"
                          value={searchFor}
                          onChange={(e) => {
                            setSearchFor(e.target.value);
                            setPageNo(1);
                          }}
                          placeholder={t("Search AWB, route, carrier...")}
                          autoFocus
                          className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none"
                        />
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setSearchFor("");
                            setShowSearch(false);
                          }}
                          className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                          title={t("Clear & Close")}
                        >
                          <IconX size={14} stroke={2.5} />
                        </button>
                      </>
                    )}
                  </div>
                  {!showSearch && (
                    <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                      {t("Search")}
                    </div>
                  )}
                </div>

                {/* Sync Order (Pending only) */}
                {pending && canUpdateOrder && (
                  <div className="relative group">
                    <button
                      onClick={syncOrder}
                      className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer"
                    >
                      <IconRefresh stroke={2.5} size={15} />
                    </button>
                    <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                      {t("Sync Orders")}
                    </div>
                  </div>
                )}

                {/* Download Excel */}
                <div className="relative group">
                  <button
                    onClick={handleDownloadXLSX}
                    disabled={isCheckboxEnabled && selectedOrders.length === 0}
                    className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer relative disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <IconDownload size={14} stroke={2.5} />
                    {selectedOrders.length > 0 && (
                      <span className="absolute -top-1 -right-1 text-[8px] bg-[#FBD037] text-[#131327] w-4 h-4 rounded-full flex items-center justify-center font-bold shadow-sm border border-white">
                        {selectedOrders.length}
                      </span>
                    )}
                  </button>
                  <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                    {t("Download XLSX")}
                  </div>
                </div>

                {/* Bulk Package Status */}
                {canUpdatePackaging && (
                  <div className="relative group">
                    <button
                      onClick={() => setShowBulkStatusModal(true)}
                      className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer"
                    >
                      <IconPackage stroke={2.5} size={15} />
                    </button>
                    <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                      {t("Bulk Status Change")}
                    </div>
                  </div>
                )}

                {/* Entries Limit Selector */}
                {ordersData?.pagination?.totalPages && ordersData.pagination.totalPages * limit > 10 && (
                  <EntriesSelector
                    value={limit}
                    options={[
                      10,
                      ...(ordersData.pagination.totalPages * limit > 10 ? [20] : []),
                      ...(ordersData.pagination.totalPages * limit > 20 ? [30] : []),
                      ...(ordersData.pagination.totalPages * limit > 50 ? [50] : []),
                      ...(ordersData.pagination.totalPages * limit > 50 ? [100] : []),
                    ]}
                    onChange={(val) => {
                      setLimit(val);
                      setPageNo(1);
                    }}
                  />
                )}

                {/* Columns Hide/Show Filter */}
                <div className="relative group">
                  <ColumnsFilter columnsData={columns} setHeadings={handleSetHeadings} />
                  <div className="absolute bottom-full mb-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded shadow-md whitespace-nowrap pointer-events-none z-50">
                    {t("Columns View")}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Table Container ── */}
          <div className="border-t border-slate-100">
            {listPending ? (
              <TableSkeleton
                columns={columns.filter((c) => c.isShow).map((c) => c.text)}
                rows={6}
              />
            ) : ordersData && ordersData?.data?.length > 0 ? (
              <AllOrderTable
                data={{ orders: ordersData?.data || [] }}
                columnsData={columns}
                currentPage={pageNo}
                limitPage={limit}
                isCheckboxEnabled={isCheckboxEnabled}
                selectedOrders={selectedOrders}
                onSelectOrder={handleSelectOrder}
                showPackAction={activeTab === "Pending"}
                onPackOrder={onPackOrder}
              />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>

        {/* ── Pagination ── */}
        {ordersData?.pagination?.totalPages &&
          ordersData.pagination.totalPages > 1 && (
            <div className="py-4">
              <Pagination
                totalPages={ordersData.pagination.totalPages}
                fetchData={handlePaginationFetch}
                currentPage={pageNo}
                totalItems={ordersData.pagination.total}
                itemLabel="orders"
              />
            </div>
          )}
          </div> {/* Left Side End */}

          {showBulkStatusModal && (
            <BulkStatusUpdateModal
              onClose={() => setShowBulkStatusModal(false)}
              fetchData={refetch}
              targetStatus="PACKED"
            />
          )}
        </div>


      {showFilter && (
        <div className="fixed inset-0 z-50 flex justify-end">
          <div
            className="absolute inset-0 bg-black/40"
            onClick={toggleFilter}
          ></div>
          <div className="relative w-[400px] h-full bg-white rounded-l-3xl shadow-lg overflow-auto transition-transform duration-300 ease-in-out">
            <FilterSidebar
              setFilters={(newFilters) => {
                setFilters(newFilters);
                setParentFilters?.(newFilters);
              }}
              onClose={toggleFilter}
              currentFilters={filters}
            />
          </div>
        </div>
      )}

      {selectedOption === "NewOrder" && showModal && (
        <AddOrdersModals
          onClose={() => setShowModal(false)}
          fetchData={refetch}
        />
      )}
      {selectedOption === "BulkOrder" && showBulkModal && (
        <OrderBulkUploadModals
          onClose={() => setShowBulkModal(false)}
          onResponseOpene={() => SetOpenResponse(true)}
          setOrderBulkResponse={setOrderBulkResponse}
        />
      )}

      {selectedOption === "ReverseOrder" && showReverseModal && (
        <ReverseOrderModal
          onClose={() => setShowReverseModal(false)}
          fetchData={refetch}
        />
      )}

      <NewCommonModalCenter
        title={t("Bulk Status Revert")}
        open={openBsrModal}
        closeButtonText={t("Cancel")}
        onClose={openBsrModalToggle}
        actionButtonText={t("Submit")}
        actionButtonOnClick={openBsrModalToggle}
      >
        <BulkStatusRevertModal />
      </NewCommonModalCenter>
      {openForwardModal && (
        <BulkForwardModal
          selectedOrders={selectedOrders}
          onClose={openForwardModalToggle}
          refetch={refetch}
        />
      )}

      {/* Bulk PDF Modal for Multiple Orders */}
      {showBulkPdfModal && (
        <BulkPdfModal
          open={showBulkPdfModal}
          onClose={() => {
            setShowBulkPdfModal(false);
            setSelectedOrders([]);
          }}
          orders={bulkPdfOrders}
          companyName={bulkPdfCompany}
        />
      )}

      <MessageModal
        open={isReverseOrderWiseOpen}
        onClose={closeReverseOrderWiseModal}
        title={t("Confirmation Required")}
        subtitle={t("Are you sure you want to reverse this order?")}
        img={"/img/inactive.svg"}
        showFooter={true}
        closeButtonText={t("Cancel")}
        actionButtonText={t("Confirm")}
        actionButtonOnClick={handleReverseOrder}
        size="md"
      />
      <MessageModal
        open={isRevertOrder}
        onClose={closeRevertOrder}
        title={t("Confirmation Required")}
        subtitle={t("Are you sure you want to revert this order?")}
        img={"/img/active.svg"}
        showFooter={true}
        closeButtonText={t("Cancel")}
        actionButtonText={t("Confirm")}
        actionButtonOnClick={handleRevertOrder}
        // isPending={activePending}
        size="md"
      />

    </>
  );
}
